import HikSetDriverCardInstitutionModal from './hik-set-driver-card-institution-modal.vue'
export default HikSetDriverCardInstitutionModal
